import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { OffCanvas, OffCanvasBody, OffCanvasHeader } from '@/components/offcanvas';
import FormInfoBooking, { FormInfoBookingProps } from '@/features/forms/FormInfoBooking/FormInfoBooking';

export interface CTAFormInfoBookingProps extends FormInfoBookingProps {
  openCanvas: boolean;
  setOpenCanvas: React.Dispatch<React.SetStateAction<boolean>>;
}

const CTAFormInfoBooking = ({ openCanvas, setOpenCanvas, ...props }: CTAFormInfoBookingProps) => {
  const [mount, setMount] = useState(false);
  const toggleCanvas = () => {
    setOpenCanvas((prevState) => !prevState);
  };

  useEffect(() => {
    setMount(true);
  }, []);
  return (
    <>
      {mount &&
        createPortal(
          <OffCanvas open={openCanvas} toggle={toggleCanvas} size="sm" scrolling={false} canvas="end">
            <OffCanvasHeader id="EmailBookingInfo" title="Informações e Reservas" />
            <OffCanvasBody>
              <FormInfoBooking {...props} />
            </OffCanvasBody>
          </OffCanvas>,
          document.body
        )}
    </>
  );
};

export default CTAFormInfoBooking;
